import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { useContext, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import Sidebar from "./Sidebar";

import { TenantAndCommerceContext } from "@main/contexts/TenantAndCommerceContext";
import { t } from "i18next";
import {
  CalendarBlank,
  Gear,
  Coins,
  Barn,
  Cardholder,
  CirclesThreePlus,
  Dog,
  CalendarPlus,
  CalendarDots,
  SignIn,
  SignOut,
  Calendar,
  Article,
  StackOverflowLogo,
  Database,
} from "@phosphor-icons/react";

import { getApi } from "@beeldit/core/helpers/api";
import useGetConfigurationAction from "@main/configurations/actions/get/useGetConfigurationAction";
import { ConfigurationsContext } from "@main/contexts/ConfigurationsContext";
import {
  ArrowsClockwise,
  Graph,
  Plugs,
  Users,
} from "@phosphor-icons/react/dist/ssr";
import useGetCommerceAction from "@main/commerces/actions/get-config/useGetCommerceAction";
import useGetTenantAction from "@main/tenants/actions/get/useGetTenantAction";
import AppNavbar from "./AppNavbar";
import { ChangeDectionProvider } from "@beeldit/core/context/ChangeDectionContext";

function Panel() {
  const { tokenLoaded, user } = useContext(AuthContext);

  /** TODO - Encapsular en una logica aparte que además compruebe que estos parametros son numericos */
  const { setTenantId } = useContext(TenantAndCommerceContext);
  const { setCommerceId } = useContext(TenantAndCommerceContext);
  const { getCommerceFunction } = useGetCommerceAction();
  const { getTenantFunction } = useGetTenantAction();

  let { tenantId, commerceId } = useParams();

  useEffect(() => {
    if (!tenantId) {
      tenantId = "1";
    }
    setTenantId(parseInt(tenantId));
    getApi().defaults.headers.common["tenantId"] = tenantId;
    if (!commerceId) {
      commerceId = "1";
    }
    setCommerceId(parseInt(commerceId));
    getApi().defaults.headers.common["commerceId"] = commerceId;
  }, []);

  useEffect(() => {
    if (!tenantId || !commerceId || !tokenLoaded) return;
    getCommerceFunction(parseInt(commerceId));
    getTenantFunction(parseInt(tenantId));
  }, [commerceId, tokenLoaded]);

  if (!tokenLoaded || !user) {
    return <div>Loading...</div>;
  }

  const items: any[] = [
    // {
    //   label: t("customers"),
    //   to: `/panel/${tenantId}/${commerceId}/customers`,
    //   icon: <AddressBookTabs size={24} />,
    //   roles: ["admin"],
    // },
    // {
    //   label: t("pets"),
    //   to: `/panel/${tenantId}/${commerceId}/pets`,
    //   icon: <Dog size={24} />,
    //   roles: ["admin"],
    // },
    {
      label: t("customers_and_pets"),
      to: `/panel/${tenantId}/${commerceId}/customers-and-pets`,
      icon: <Dog size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("new_booking"),
      to: `/panel/${tenantId}/${commerceId}/booking?new=true`,
      icon: <CalendarPlus size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("bookings"),
      to: `/panel/${tenantId}/${commerceId}/bookings`,
      icon: <CalendarDots size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("arrival_bookings"),
      to: `/panel/${tenantId}/${commerceId}/arrival-bookings`,
      icon: <SignIn size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("departure_bookings"),
      to: `/panel/${tenantId}/${commerceId}/departure-bookings`,
      icon: <SignOut size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("calendar"),
      to: `/panel/${tenantId}/${commerceId}/bookings-calendar`,
      icon: <Calendar size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("payments"),
      to: `/panel/${tenantId}/${commerceId}/payments`,
      icon: <Coins size={24} />,
      roles: ["admin"],
    },
    {
      label: t("invoices"),
      to: `/panel/${tenantId}/${commerceId}/invoices`,
      icon: <Article size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: t("delivery_notes"),
      to: `/panel/${tenantId}/${commerceId}/delivery-notes`,
      icon: <Article size={24} />,
      roles: ["admin", "worker"],
    },
    {
      label: (
        <>
          <Gear size={24} />
          {t("configurations")}
        </>
      ),
      roles: ["admin"],
      children: [
        {
          label: t("users"),
          to: `/panel/${tenantId}/${commerceId}/configurations/users`,
          icon: <Users size={24} />,
          roles: ["admin"],
        },
        {
          label: t("rooms"),
          to: `/panel/${tenantId}/${commerceId}/configurations/rooms`,
          icon: <Barn size={24} />,
          roles: ["admin"],
        },
        {
          label: t("payment_methods"),
          to: `/panel/${tenantId}/${commerceId}/configurations/payment-methods`,
          icon: <Coins size={24} />,
          roles: ["admin"],
        },
        {
          label: t("fees"),
          to: `/panel/${tenantId}/${commerceId}/configurations/fees`,
          icon: <Cardholder size={24} />,
          roles: ["admin"],
        },
        {
          label: t("extras"),
          to: `/panel/${tenantId}/${commerceId}/configurations/extras`,
          icon: <CirclesThreePlus size={24} />,
          roles: ["admin"],
        },
        {
          label: t("holidays"),
          to: `/panel/${tenantId}/${commerceId}/configurations/holidays`,
          icon: <CalendarBlank size={24} />,
          roles: ["admin"],
        },
        {
          label: t("booking_texts"),
          to: `/panel/${tenantId}/${commerceId}/configurations/configuration`,
          icon: <Article size={24} />,
          roles: ["admin"],
        },
        {
          label: t("users_activity"),
          to: `/panel/${tenantId}/${commerceId}/configurations/users-activity`,
          icon: <StackOverflowLogo size={24} />,
          roles: ["admin"],
        },
        {
          label: t("updates"),
          to: `/panel/${tenantId}/${commerceId}/configurations/updates`,
          icon: <ArrowsClockwise size={24} />,
          roles: ["admin"],
        },
        {
          label: t("integrations"),
          to: `/panel/${tenantId}/${commerceId}/configurations/integrations`,
          icon: <Plugs size={24} />,
          roles: ["admin"],
        },
        {
          label: t("reports"),
          to: `/panel/${tenantId}/${commerceId}/configurations/reports`,
          icon: <Graph size={24} />,
          roles: ["admin"],
        },
        {
          label: t("bd_connections"),
          to: `/panel/${tenantId}/${commerceId}/configurations/bd-connections`,
          icon: <Database size={24} />,
          roles: ["admin"],
        }
      ],
    },
  ];

  return (
    <div>
      <ChangeDectionProvider>
        <div className="admin container-fluid">
          <AppNavbar items={items}></AppNavbar>
          <div className="row">
            {/* <Sidebar items={items} /> */}
            <div className="page-content">
              <Outlet />
              <div className="text-end text-secondary mt-3">
                License: Mascotas Nazarenas S.L
              </div>
            </div>
          </div>
        </div>
      </ChangeDectionProvider>
    </div>
  );
}

export default Panel;
